import { useRef } from "react";

import type { SignalEventType } from "app/pages/sales-intelligence/sub-modules/account-overview/company/services/signals/types";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";
import type { TrackingColumnName } from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/types";

interface IUseTrackedSignalTooltipProps<V extends number> {
    field: TrackingColumnName;
    value: V;
}

export interface IUseTrackedSignalTooltipResponse {
    onTrackedTooltipClick: VoidFunction;
    onTrackedSignalTypeClick: (signalEventType: SignalEventType) => void;
    onTrackedSignalArticleClick: (signalEventType: SignalEventType, articleTitle: string) => void;
    onTrackedTooltipOpen: VoidFunction;
}

export const useTrackedSignalTooltip = <V extends number>(
    props: IUseTrackedSignalTooltipProps<V>,
): IUseTrackedSignalTooltipResponse => {
    const isTooltipOpenTracked = useRef<boolean>(false);

    const onTrackedTooltipClick = () => {
        trackingService.columns.trackViewAllItems(props.field);
    };

    const onTrackedSignalTypeClick = (signalEventType: SignalEventType) => {
        trackingService.columns.trackViewSignalType(props.field, signalEventType);
    };

    const onTrackedSignalArticleClick = (signalType: SignalEventType, articleTitle: string) => {
        trackingService.columns.trackViewSignalArticle(props.field, signalType, articleTitle);
    };

    const onTrackedTooltipOpen = (): void => {
        if (isTooltipOpenTracked.current) {
            return;
        }

        trackingService.columns.trackSignalsCountTooltipOpen(props.value);
        isTooltipOpenTracked.current = true;
    };

    return {
        onTrackedTooltipClick,
        onTrackedTooltipOpen,
        onTrackedSignalTypeClick,
        onTrackedSignalArticleClick,
    };
};
